import { request as sonataRequest } from 'sonata-react-components';

import type {
  AdvertiserWithExtraData,
  MultiFlightAdvertisersState,
  PaginationResult
} from 'sonata-static-storage/lib/common/common.types';
import type {
  MediaAdvertiserUserInterface,
  MediaAdvertiserUserPopulated
} from 'sonata-static-storage/lib/schemas/mediaInfo/mediaAdvertiserUser.schema';
import type { Token } from './common.types';

export async function getAdvertisers(
  userId: string,
  params: Record<string, any>,
  token: Token
): Promise<PaginationResult<MediaAdvertiserUserPopulated | AdvertiserWithExtraData>> {
  return sonataRequest.makeRequest(
    `${taptap.config.backendUrlBase}multiflight/advertiser/${userId}`,
    {
      method: 'GET',
      params: new URLSearchParams(params)
    },
    token
  );
}

export async function getAdvertiserVolumetry(
  userId: string,
  filters: Record<string, string | number | boolean | (string | number)[]>,
  token?: Token
): Promise<MultiFlightAdvertisersState> {
  filters = {
    unlimited: true,
    ...filters
  };
  return sonataRequest.makeRequest(
    `${taptap.config.backendUrlBase}multiflight/advertiser/${userId}/statesVolumetry`,
    {
      method: 'GET',
      params: new URLSearchParams(filters as Record<string, string>)
    },
    token
  );
}

export async function deleteAdvertiser(
  id: MediaAdvertiserUserInterface['_id'],
  userId: string,
  token?: Token
): Promise<void> {
  return sonataRequest.makeRequest(
    `${taptap.config.backendUrlBase}multiflight/advertiser/${userId}/${id}`,
    {
      method: 'DELETE'
    },
    token
  );
}

export const generateAdvertiser = (userId: string, data: any, token?: Token) => {
  return sonataRequest.makeRequest(
    `${taptap.config.sonataBackendUrl}multiflight/advertiser/${userId}`,
    {
      data,
      method: 'POST'
    },
    token
  );
};

export const updateMediaAdvertiser = (
  userId: string,
  id: MediaAdvertiserUserInterface['_id'],
  data: any,
  token?: Token
) => {
  return sonataRequest.makeRequest(
    `${taptap.config.sonataBackendUrl}multiflight/advertiser/${userId}/${id}`,
    {
      data,
      method: 'PUT'
    },
    token
  );
};
